import axios from "axios";
import { getLanguage } from '@/i18n';
import { getToken } from '@/utils/auth';
import { tansParams } from '@/utils/common';
import cache from '@/utils/cache';
import { errorCode } from '@/utils/errorCode';
import { encryptBase64, encryptWithAes, generateAesKey, decryptWithAes, decryptBase64 } from '@/utils/crypto';
import { encrypt, decrypt } from '@/utils/jsencrypt';
// import { MessageBox, Message, Notification } from 'element-ui';
import { Message, Notification } from 'element-ui';
const encryptHeader = 'encrypt-key';

//是否是重新登录
export const isRelogin = { show: false };

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers['clientid'] = process.env.VUE_APP_CLIENT_ID;

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 50000
});


service.interceptors.request.use(
    (config) => {
        config.headers['Content-Language'] = getLanguage();
        const isToken = config.headers?.isToken === false;
        const isRepeatSubmit = config.headers?.repeatSubmit === false;
        const isEncrypt = config.headers?.isEncrypt === 'true';

        if (getToken() && !isToken) {
            config.headers['Authorization'] = 'Bearer ' + getToken();
        }

        if (config.method === 'get' && config.params) {
            let url = config.url + '?' + tansParams(config.params);
            url = url.slice(0, -1);
            config.params = {};
            config.url = url;
        }

        if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
            const requestObj = {
                url: config.url,
                data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
                time: new Date().getTime()
            };
            const sessionObj = cache.session.getJSON('sessionObj');
            if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
                cache.session.setJSON('sessionObj', requestObj);
            } else {
                const s_url = sessionObj.url;
                const s_data = sessionObj.data;
                const s_time = sessionObj.time;
                const interval = 500;
                if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
                    const message = 'Data is being processed, please do not submit repeatedly';
                    console.warn(`[${s_url}]: ` + message);
                    return Promise.reject(new Error(message));
                } else {
                    cache.session.setJSON('sessionObj', requestObj);
                }
            }
        }

        if (isEncrypt && (config.method === 'post' || config.method === 'put')) {
            const aesKey = generateAesKey();
            config.headers[encryptHeader] = encrypt(encryptBase64(aesKey));
            config.data = typeof config.data === 'object' ? encryptWithAes(JSON.stringify(config.data), aesKey) : encryptWithAes(config.data, aesKey);
        }

        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    (res) => {
        const keyStr = res.headers[encryptHeader];
        if (keyStr != null && keyStr != '') {
            const data = res.data;
            const base64Str = decrypt(keyStr);
            const aesKey = decryptBase64(base64Str.toString());
            const decryptData = decryptWithAes(data, aesKey);
            res.data = JSON.parse(decryptData);
        }

        const code = res.data.code || 200;
        const msg = errorCode[code] || res.data.msg || errorCode['default'];
        if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
            return res.data;
        }
        
        if (code === 401) {
            // if (!isRelogin.show) {
            //     isRelogin.show = true;
            //     MessageBox.confirm('Login status has expired, you can stay on this page, or log in again', 'System Notification', {
            //         confirmButtonText: 'Login again',
            //         cancelButtonText: 'Cancel',
            //         type: 'warning',
            //         center: true,
            //         confirmButtonClass:'confirmButtonClass'
            //     }).then(() => {
            //         isRelogin.show = false;
            //         this.$store.dispath('logout').then(() => {
            //             location.href = process.env.VUE_APP_CONTEXT_PATH + 'index';
            //         });
            //     }).catch(() => {
            //         isRelogin.show = false;
            //     });
            // }
            return Promise.reject('Invalid session, or session has expired, please log in again.');
        } else if (code === 500) {
            Message({ message: msg, type: 'error' });
            return Promise.reject(new Error(msg));
        } else if (code === 601) {
            Message({ message: msg, type: 'warning' });
            return Promise.reject(new Error(msg));
        } else if (code !== 200) {
            Notification.error({ title: msg });
            return Promise.reject('error');
        } else {
            return Promise.resolve(res.data);
        }
    },
    (error) => {
        let { message } = error;
        if (message == 'Network Error') {
            message = 'Backend API connection exception';
        } else if (message.includes('timeout')) {
            message = 'System API request timeout';
        } else if (message.includes('Request failed with status code')) {
            message = 'System API ' + message.substr(message.length - 3) + ' exception';
        }
        Message({ message: message, type: 'error', duration: 5 * 1000 });
        return Promise.reject(error);
    }
);

export default service;